var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.main_class},_vm._l((_vm.columns),function(item,index){return _c('div',{key:index,class:item.class},[_vm._t(item.key)],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }